import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {selectIsAnyConsumerProducts} from '@/state/selectors/consumer';
import {selectIsLoyaltyMember} from '@/state/selectors/consumerLoyalty';
import {isBannerEnabled} from '@/utils/bannerUtils';

export const useDynamicDesktopHighlights = (carousels) => {
    const isAnyDeviceRegistered = useSelector(selectIsAnyConsumerProducts);
    const isLoyaltyMember = useSelector(selectIsLoyaltyMember);

    return useMemo(() => {
        if (!carousels?.length) return;

        const dynamicCarousels = carousels.map((carousel) => {
            const {highlights} = carousel;
            const filtered = highlights.filter((highlight) =>
                isBannerEnabled(highlight?.banner, isAnyDeviceRegistered, isLoyaltyMember)
            );

            return filtered.length ? {...carousel, highlights: filtered} : null;
        });

        return dynamicCarousels.filter(Boolean);
    }, [carousels, isAnyDeviceRegistered, isLoyaltyMember]);
};
